import axios from 'axios';
import { Theme, ThemeObject } from 'domains/appDomain';
import defaultThemeObject from '../styles/theme.default.json';
const themeService = {
  getDefaultThemeObject: () => {
    return defaultThemeObject;
  },

  getThemeObject: async (theme: Theme): Promise<ThemeObject> => {
    if (theme === 'default') {
      return defaultThemeObject;
    }
    const { data } = await axios.get<ThemeObject>(`/themes/${theme}.json`);
    return {
      ...defaultThemeObject,
      ...data,
    };
  },
};
export default themeService;
